import React from 'react';
import type { SortDescriptor } from '@react-types/shared';
import { createSortDescriptor } from '@/components/table';
import { ErrorItem } from '@/types';

export const useErrorzSorting = (errorz: ErrorItem[]) => {
  const [sortDescriptor, setSortDescriptor] = React.useState<SortDescriptor | undefined>(undefined);

  const sortedErrors = React.useMemo(() => {
    if (!sortDescriptor?.column) return errorz;

    const copy = [...errorz];
    const { column, direction } = sortDescriptor;

    const compareStrings = (a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' });
    const compareNumbers = (a: number, b: number) => a - b;

    copy.sort((a, b) => {
      let cmp = 0;

      switch (column) {
        case 'message':
          cmp = compareStrings(a.message, b.message);
          break;
        case 'stage':
          cmp = compareStrings(a.stage, b.stage);
          break;
        case 'status':
          cmp = compareStrings(a.status, b.status);
          break;
        case 'ip':
          cmp = compareStrings(a.ip, b.ip);
          break;
        case 'created_at':
          cmp = compareStrings(a.created_at, b.created_at);
          break;
        case 'server_timestamp':
          cmp = compareNumbers(a.server_timestamp, b.server_timestamp);
          break;
        default:
          cmp = 0;
      }

      return direction === 'descending' ? -cmp : cmp;
    });

    return copy;
  }, [errorz, sortDescriptor]);

  return { sortDescriptor, setSortDescriptor, sortedErrors };
};
